import moment from "moment";
import React from "react";
import Chart from "react-apexcharts";
import { usePriceFormatter } from "../../../hooks";

type LineChartProps = {
  data?: { x: string; y: number }[]; // Optional data prop
  width?: string | number;
  height?: string | number;
  timeline?: string | number;
  lineColor?: string;
};

const LineChart: React.FC<LineChartProps> = ({
  data,
  width = "100%",
  height = "300px",
  timeline,
  lineColor = "#FF4500",
}) => {

  const formatter = usePriceFormatter();

  const validatedData = data || []

  const options: ApexCharts.ApexOptions = {
    chart: {
      id: "basic-line",
      background: "transparent",
      toolbar: { show: false },
    },
    xaxis: {
      type: "category",
      labels: {
        show: true,
        style: { colors: "white" },
        rotate: 0,
        formatter: (value) => {
          const date = moment(value);
          if (timeline === "1 Day") {
            return date.format("HH:mm");
          } else if (timeline === "5 Day" || timeline === "1 Month") {
            return date.format("MMM/DD");
          } else if (timeline === "6 Month" || timeline === "1 Year" || timeline === "5 Years" || timeline === "All") {
            return date.format("MMM/YY");
          }
          return date.format("DD MMM HH:mm"); // Default fallback
        },
      },
      axisBorder: { show: true },
      axisTicks: { show: false },
      tooltip: { enabled: false },
    },
    yaxis: {
      axisBorder: {
        show: true,
        color: "#ccc",
        width: 1,
      },
      labels: { show: true, style: { colors: 'white' } },
    },
    stroke: {
      curve: "smooth",
      width: 2,
      colors: [lineColor],
    },
    tooltip: {
      enabled: true,
      custom: ({ series, seriesIndex, dataPointIndex, w }) => {
        const price = series[seriesIndex][dataPointIndex];
        const time = new Date(
          w.globals.seriesX[seriesIndex][dataPointIndex]
        ).toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        });
        const date = moment(w.config.series[seriesIndex].data[dataPointIndex].x).format(timeline == "1 Day" ? "MM-DD-YYYY, HH:mm:ss" : "MM-DD-YYYY");
        return `<div style="background-color: #333; display: flex; gap: 5px; color: #fff; padding: 5px; border-radius: 5px;">
                  <span>${formatter.display(price, { showSymbol: true })}</span>
                  <span>|</span>
                  <span>${date}</span>
                </div>`;
      },
    },
    grid: { show: false },
    markers: {
      size: 0,
      colors: ["#FFFFFF"],
      strokeWidth: 2,
      strokeColors: lineColor,
      hover: { size: 7 },
    },
  };

  const series: ApexAxisChartSeries = [
    {
      name: "Price",
      data: validatedData,
    },
  ];

  return (
    <div className="line-chart">
      <Chart key={timeline} options={options} series={series} type="line" width={width} height={height} />
    </div>
  );
};

export default LineChart;
